import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClockInterval = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M17.9177 11.0042C17.4975 8.4883 15.5117 6.50251 12.9958 6.08226C12.4511 5.99127 12 6.44772 12 7V11C12 11.5523 12.4477 12 13 12H17C17.5523 12 18.0087 11.5489 17.9177 11.0042Z",
		fill: "currentColor"
	})]
});
export default SvgClockInterval;
